import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'it-management',
  children: {
    new: {
      path: 'new',
    },
    importAssets: {
      path: 'import-assets/*',
      size: 'full',
      level: 2,
    },
    importAssetsResult: {
      path: 'import-result',
      size: 'full',
    },
    assetId: {
      path: ':assetId',
      children: {
        edit: {
          path: 'edit',
        },
        documents: {
          path: 'documents',
        },
        overview: {
          path: 'overview',
        },
      },
    },
    edit: {
      path: 'edit/:assetId',
    },
  },
} as const satisfies Location
